export const B2B_DENIED_DOMAINS = [process.env.NEXT_PUBLIC_SGTM_EVENT_API_ENDPOINT] as const
